export * from './projects/projects.page'
export * from './home/home.page'
export * from './about-me/about-me.page'
